import { render, staticRenderFns } from "./CreatePasswordPage.vue?vue&type=template&id=3020c9be&"
import script from "./CreatePasswordPage.vue?vue&type=script&lang=js&"
export * from "./CreatePasswordPage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePasswordPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports